// extracted by mini-css-extract-plugin
export default {"wrap":"ImagesPage_wrap__TSy2O","itemWrap":"ImagesPage_itemWrap__kzud9","itemDelete":"ImagesPage_itemDelete__cIq4t"};